import {Col, Row, Tabs, TabsProps, Typography} from "antd";
import React, {useState} from "react";
import ApplicablePolicy from "./components/ApplicablePolicy/ApplicablePolicy";
import ListPolicy from "./components/ListPolicy/ListPolicy";
import Discount from "./components/Discount/Discount";
import "./PolicyInfo.scss";

const PolicyInfo = props => {
  const [isApplicablePolicy, setIsApplicablePolicy] = useState<boolean>(false);
  const [isListPolicy, setIsListPolicy] = useState<boolean>(true);
  const [isDiscount, setIsDiscount] = useState<boolean>(false);

  const setIAP = () => {
    setIsApplicablePolicy(true);
    setIsListPolicy(false);
    setIsDiscount(false);
  };
  const setILP = () => {
    setIsApplicablePolicy(false);
    setIsListPolicy(true);
    setIsDiscount(false);
  };
  const setId = () => {
    setIsApplicablePolicy(false);
    setIsListPolicy(false);
    setIsDiscount(true);
  };

  return (
    <Row className="policy-info-container" gutter={[0, 12]}>
      <Row
        style={{
          gap: "12px",
        }}
      >
        {isListPolicy ? (
          <Typography.Text strong>Thẻ khám bệnh</Typography.Text>
        ) : (
          <Typography.Text strong type="secondary" onClick={setILP}>
            Thẻ khám bệnh
          </Typography.Text>
        )}
        {isApplicablePolicy ? (
          <Typography.Text strong>Chính sách áp dụng</Typography.Text>
        ) : (
          <Typography.Text strong type="secondary" onClick={setIAP}>
            Chính sách áp dụng
          </Typography.Text>
        )}
        {isDiscount ? (
          <Typography.Text strong>Giảm giá</Typography.Text>
        ) : (
          <Typography.Text strong type="secondary" onClick={setId}>
            Giảm giá
          </Typography.Text>
        )}
      </Row>
      <Row>
        {isListPolicy ? <ListPolicy {...props} /> : null}
        {isApplicablePolicy ? <ApplicablePolicy {...props} /> : null}
        {isDiscount ? <Discount /> : null}
      </Row>
    </Row>
  );
};

export default PolicyInfo;
